/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Language } from '../../models/language';

export interface GetShoppingAdsUkrLanguageLocalizationFeedFacebook$Params {
  lang: Language;
}

export function getShoppingAdsUkrLanguageLocalizationFeedFacebook(http: HttpClient, rootUrl: string, params: GetShoppingAdsUkrLanguageLocalizationFeedFacebook$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, getShoppingAdsUkrLanguageLocalizationFeedFacebook.PATH, 'get');
  if (params) {
    rb.path('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

getShoppingAdsUkrLanguageLocalizationFeedFacebook.PATH = '/api/v1/feed/shopping/facebook/localization/{lang}';
